module.exports = __webpack_public_path__ + "img/screen.4ee8f3e3.png";